import { render } from "./AddUser.vue?vue&type=template&id=148328c8"
import script from "./AddUser.vue?vue&type=script&lang=js"
export * from "./AddUser.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/userAccounts/AddUser.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "148328c8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('148328c8', __exports__)) {
    console.log('reload')
    api.reload('148328c8', __exports__)
  }
  
  module.hot.accept("./AddUser.vue?vue&type=template&id=148328c8", () => {
    console.log('re-render')
    api.rerender('148328c8', render)
  })

}


export default __exports__